import React from "react";
import AAutoComplete from "../../../../../../common/form-fields-mui/AAutoComplete";

const AvailablePosDropdown = ({
  isDisable,
  value,
  onChangeHandler,
  posDropdown,
}) => {
  return (
    <div className="flex-fill">
      <span className="semi-bold text-dark mb-2 d-block">Vendor Type</span>
      <AAutoComplete
        currentValue={value}
        handleChange={(e) => onChangeHandler(e)}
        height="47px"
        isMulti={false}
        items={posDropdown}
        isDisabled = {isDisable}
      />
    </div>
  );
};

export default AvailablePosDropdown;
